<template>
  <div class = "main-container-content" v-if="totalRecords === null">
    <img id = "rewards_image"/>
    <p class = "invite-text" v-if = "refereeBonus === 0">Invite a friend and get 1% of their first investment</p>
    <p class = "invite-text" v-else>Congratulations on receiving &#x20B9;{{ refereeBonus | localeAmountPaisa }} as referee bonus from your friend. Invite your friends and get 1% of their first investment.</p>
    <div class = "invite-container">
        <button class = "buttonCopy btn_new btn-secondary-new" @click="copyToClipboard()">
            <v-icon class="material-icons-round icons">
                content_copy
            </v-icon>
            {{generatedReferralCode}}
        </button>
        <button class = "buttonSubmit btn_new btn-secondary-new" @click="shareReferral">
            Invite Friends
        </button>
        <v-snackbar v-model="isCopied" app timeout="3000">
            Copied to clipboard!
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isCopied = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
  </div>
  <div class = "main-container-content-nonEmptyState" id = "scrollingContainer" v-else>
    <div class = "nonEmptyState">
        <p class = "referralLinkText">Refer & Earn</p>
        <div class = "icons-container">
            <v-icon class="material-icons-round bannerIcons" @click="copyToClipboard()">
                content_copy
            </v-icon>
            <v-icon class="material-icons-round bannerIcons" @click="shareReferral">
                share
            </v-icon>
        </div>
    </div>
    <div class = "rewardsTable" @scroll="loadMoreRewards">
        <v-data-table
            :headers="headers"
            :items="rewards"
            :items-per-page="itemsPerPage"
            :header-props="{ sortIcon: null }"
            :hide-default-footer="true"
            mobile-breakpoint="0"
        >
            <template v-slot:item.status="{ item }">
                <v-chip :class="getStatusColor(item.status, item.amount)">
                    {{ changeStatus(item.status, item.amount) }}
                </v-chip>
            </template>
            <template v-slot:item.amount="{ item }">
                &#x20B9;{{ changeAmount(item.amount) | localeAmountPaisa }}
            </template>
            <template v-slot:item.name="{ item }">
                {{ changeName(item.name, item.phoneNumber)}}
            </template>
        </v-data-table>
    </div>
    <div class = "loaderContainer">
        <v-progress-circular
        v-if="isLoading"
        indeterminate
        color="#13285e"
        ></v-progress-circular>
    </div>
        <v-snackbar v-model="isCopied" app timeout="3000">
            Copied to clipboard!
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isCopied = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
  </div>
</template>

<script>
import lenderService from '@/services/lenderService'
export default {
    props: {
        rewardAmount: Number
    },
    data () {
        return {
            generatedReferralCode: null,
            isCopied: false,
            headers: [
                {
                    text: 'Friends',
                    value: 'name',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Rewards Earned',
                    value: 'amount',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Status',
                    value: 'status',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                }
            ],
            rewards: [],
            itemsPerPage: 10,
            page: 1,
            totalRecords: null,
            limitDocuments: 10,
            refereeBonus: 0,
            isLoading: false
        }
    },
    mounted () {
        this.$store.commit('isLoading')
        this.generatedReferralCode = this.$store.state.dashboard.generatedReferralCode
        this.getRewardData()
    },
    methods: {
        getRewardData () {
            if (this.totalRecords !== this.rewards.length) {
                this.isLoading = true
                const query = 'itemsPerPage=' + this.limitDocuments + '&page=' + this.page
                lenderService.getReferralData(query).then((response) => {
                    if (response.status === 200) {
                        this.$store.commit('isNotLoading')
                        this.isLoading = false
                        this.rewards = response.data[0].rewardData
                        if (response.data[0]?.totalCount?.totalRecords) {
                            this.totalRecords = response.data[0].totalCount.totalRecords
                            this.itemsPerPage = this.rewards.length
                        }
                        if (response.data[1][0]?.amount) {
                            this.refereeBonus = response.data[1][0]?.amount
                        }
                    }
                })
            }
        },
        loadMoreRewards (e) {
            var { scrollTop, clientHeight, scrollHeight } = e.target
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                this.page += 1
                this.getRewardData()
            }
        },
        changeName (name, phoneNumber) {
            if (name === undefined || name === null) {
                return phoneNumber
            } else {
                return name.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')
            }
        },
        changeAmount (amount) {
            var updatedAmount = amount
            if (updatedAmount === null || updatedAmount === undefined) {
                updatedAmount = '--'
            }
            return updatedAmount
        },
        getStatusColor (status, amount) {
            if (status === 'pending' || amount === undefined || amount === null) {
                return 'transactionPending'
            } else if (status === 'credited') {
                return 'transactionSuccess'
            }
        },
        changeStatus (status, amount) {
            if (status === 'pending' || amount === undefined || amount === null) {
                return 'Pending'
            } else if (status === 'credited') {
                return 'Received'
            }
        },
        copyToClipboard () {
            navigator.clipboard.writeText(
                this.generatedReferralCode
            )
            this.isCopied = true
        },
        shareReferral () {
            navigator.clipboard.writeText(
                `Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=${this.generatedReferralCode}`
            )
            this.isCopied = true
            if (navigator.share) {
                // Web Share API is supported
                navigator
                    .share({
                        title: 'IndiaP2P Invest',
                        text:
                            'Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=' +
                            this.generatedReferralCode
                    })
            } else {
                // Fallback
                navigator.clipboard
                    .writeText(
                        `Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=${this.generatedReferralCode}`
                    )
                    .then(() => {
                        this.isCopied = true
                    })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .v-data-table__wrapper {
        overflow: unset;
    }
    ::v-deep .v-data-table__wrapper .sticky-header {
        background: #f2f6ff !important;
        position: sticky;
        top: 0;
    }
    .loaderContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .rewardsTable {
        max-height: 250px;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .rewardsTable::-webkit-scrollbar {
        width: 0 !important
    }
    ::v-deep .primary {
        background-color: #002fa7 !important;
        border-color: #002fa7 !important;
    }
    ::v-deep .v-pagination__item {
        height: 25px;
        min-width: 25px;
        font-size: 14px;
    }
    ::v-deep .v-pagination__navigation {
        height: 25px;
        width: 25px
    }
    ::v-deep .v-icon.v-icon {
        font-size: 14px;
    }
    // ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:last-child {
    //     border: none;
    // }
    // ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    //     border: none;
    // }
    // ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    //     border-bottom: none;
    // }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        color: #6a6a6a;
        font-size: 13px
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        height: 38px;
        font-size: 13px
    }
    ::v-deep .v-data-table-header {
        background-color: #f6f6f6;
    }
    .pagination {
        padding-top: 20px;
    }
    ::v-deep .v-pagination {
      justify-content: flex-end;
    }
    ::v-deep .v-chip__content {
        font-size: 13px;
        display: flex;
        justify-content: center;
    }
    .v-chip.v-size--default {
        border-radius: 8px
    }
    .transactionSuccess {
        width: 75px;
        background-color: #D0FAEB !important;
        color: #232323;
    }
    .transactionPending {
        width: 75px;
        background-color: #FAEFD0 !important;
        color: #232323;
    }
    .v-chip {
        display: inline-block;
    }
    .icons-container {
        display: flex;
        justify-content: flex-end;
    }
    .bannerIcons {
        color: #FFFFFF;
        cursor: pointer;
        margin-right: 10px;
        font-size: 22px !important;
    }
    .referralLinkText {
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
        margin-bottom: 0px;
    }
    .nonEmptyState {
        background: #13285E;
        width: 100%;
        height: auto;
        padding: 10px;
        display: flex;
        flex-direction: row;
    }
    #rewards_image {
        content: url('/img/rewardsEmptyState.svg');
        width: 50% ;
        height: auto;
    }
    .main-container-content {
        width: 45%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .main-container-content-nonEmptyState {
        width: 68%;
        display: flex;
        flex-direction: column;
    }
    .invite-container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .invite-text {
        text-align: center;
        padding-top: 20px;
        font-weight: 500;
        font-size: 18px;
        color: #4F4F4F;
    }
    .buttonCopy {
        height: 40px !important;
        background: #e0e0e0 !important;
        border-color: #e0e0e0 !important;
        font-size: 12px !important;
        color: #232323 !important;
        margin-right: 5px !important;
        width: 130px !important;
    }
    .buttonSubmit {
        height: 40px !important;
        font-size: 13px !important;
        margin-left: 15px !important;
        width: 130px !important;
    }
    .icons {
        font-size: 18px !important;
    }

    @media (max-width: 1200px) {
        .main-container-content {
            width: 60%;
        }
        .main-container-content-nonEmptyState {
            width: 65%;
        }
        .referralLinkText {
            font-size: 15px;
        }
        .nonEmptyState {
            padding: 9px;
        }
    }
    @media (max-width:768px){
        .buttonCopy {
            height: 35px !important;
            font-size: 12px !important;
            width: 110px !important;
        }
        .buttonSubmit {
            height: 35px !important;
            font-size: 12px !important;
            width: 110px !important;
        }
        .icons {
            font-size: 16px !important;
        }
        .referralLinkText {
            font-size: 14px;
        }
        .nonEmptyState {
            padding: 9px;
        }
        .main-container-content-nonEmptyState {
            width: 85%;
        }
    }
    @media (max-width: 480px) {
        .main-container-content {
            width: 85%;
        }
        .main-container-content-nonEmptyState {
            width: 100%;
        }
        .referralLinkText {
            font-size: 12px;
        }
        .nonEmptyState {
            padding: 8px;
        }
        .invite-text {
            font-size: 14px;
        }
        .buttonCopy {
            height: 35px !important;
            font-size: 12px !important;
            width: 110px !important;
        }
        .buttonSubmit {
            height: 35px !important;
            font-size: 12px !important;
            width: 110px !important;
        }
        .icons {
            font-size: 16px !important;
        }
        .bannerIcons {
            font-size: 19px !important;
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
            font-size: 11px
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
            font-size: 11px
        }
        ::v-deep .v-chip__content {
            font-size: 11px;
        }
    }
</style>
